// @flow

import { freeze } from "icepick";
import {
    FETCH_MONTHLY_PHOTOS_SUCCESS,
    FETCH_MONTHLY_PHOTOS_ERROR,
    FETCH_PHOTOS_SUCCESS,
    FETCH_PHOTOS_ERROR,
    SHOW_MONTH,
    HIDE_MONTH
} from "./actions";

import type { MessagesState } from "./types";

const initialState: MessagesState = freeze({
    all: null,
    showPhotoTitle: null
});

export const getShowPhotoSummary = state => {
    if (state.all === null || state.showPhotoTitle === null) {
        return null;
    }

    for (let i = 0; i < state.all.length; i += 1) {
        if (state.all[i].title === state.showPhotoTitle) {
            return state.all[i];
        }
    }
    return null;
};

export default (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_MONTHLY_PHOTOS_SUCCESS:
            return freeze({
                ...state,
                all: payload
            });
        case SHOW_MONTH:
            return freeze({
                ...state,
                showPhotoTitle: payload.title
            });
        case HIDE_MONTH:
            return freeze({
                ...state,
                showPhotoTitle: null
            });
        case FETCH_PHOTOS_SUCCESS:
            if (state.all !== null) {
                const newAll = [];

                for (let i = 0; i < state.all.length; i += 1) {
                    if (state.all[i].title === payload.photoSummary.title) {
                        const photoSummary = { ...state.all[i], photos: payload.photos };
                        newAll.push(photoSummary);
                    } else {
                        newAll.push(state.all[i]);
                    }
                }
                const newState = { ...state, all: newAll };
                return freeze(newState);
            }
            return state;
        case (FETCH_MONTHLY_PHOTOS_ERROR, FETCH_PHOTOS_ERROR):
            return freeze({
                ...state,
                hasErrors: true
            });

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/state/photos/reducer.js